import { useEffect, useState } from "react";
import {
  fetchManpowerReportSummaryById,
  fetchManpowerReportDetails,
} from "@api/manPowerReports";

export const useManpowerReports = () => {
  const [getManpowerReportSummaryData, setGetManpowerReportSummaryData] =
    useState<any>({});
  const [getManpowerReportDetailsData, setGetManpowerReportDetailsData] =
    useState<any>([]);

  const [
    getManpowerReportSummaryDataError,
    setGetManpowerReportSummaryDataError,
  ] = useState(false);
  const [
    getManpowerReportDetailsDataError,
    setGetManpowerReportDetailsDataError,
  ] = useState(false);

  // const [positionId, setPositionId] = useState<number | null>(null);

  const [query, setQuery] = useState<any>(null);

  // const handleParams = (id: number) => setPositionId(id);
  const handleQuery = (key: string, value: number | string) =>
    setQuery((prev: any) => ({
      ...prev,
      [key]: value,
    }));

  // useEffect(() => {
  //   if (query) {
  //   }
  // }, [query]);

  useEffect(() => {
    if (query) {
      fetchManpowerReportSummaryById(query)
        .then((data: any) => {
          if (data?.resData?.data?.length) {
            data?.resData?.data?.push({
              officeInfoBn: "মোট",
              employeePost: data?.resData?.totalPost,
              totalCurrentEmployee: data?.resData?.totalEmployee,
              totalVacancy: data?.resData?.vacancy,
            });
          }
          setGetManpowerReportSummaryData(data.resData);
          // setQuery({ query });
        })
        .catch((err: any) => {
          setGetManpowerReportSummaryDataError(true);
        });

      fetchManpowerReportDetails(query)
        .then((data: any) => {
          const _data = [
            {
              data: data.resData?.headquarters,
              name: data.resData?.headquarterNameBn,
            },
            {
              data: data.resData?.integratedDistrictOffice,
              name: data.resData?.integratedDistrictOfficeNameBn,
            },
            {
              data: data.resData?.divisionalOffice,
              name: data.resData?.divisionalOfficeNameBn,
            },
          ];
          setGetManpowerReportDetailsData(_data);
        })
        .catch((err: any) => {
          setGetManpowerReportDetailsDataError(true);
        });
    }
  }, [query]);

  return {
    getManpowerReportSummaryData,
    getManpowerReportSummaryDataError,
    getManpowerReportDetailsData,
    getManpowerReportDetailsDataError,
    // handleParams,
    // positionId,
    handleQuery,
  };
};
